import { mapState } from 'vuex'

export default {
  name: 'sticky-header',
  data: () => ({
    spaceBetweenNavs: null,
    visibleBodyArea: null,
    unsticked: false,
    isScrolling: undefined,
    isFirstLoad: true,
    oldScroll: null,
    isScrollingUp: false,
    alert: null,
    greetingSignInIsMounted: false
  }),
  props: {
    fixedHeader: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    ...mapState('global', ['isSitecore']),
    headerNavHeight() {
      const headerGlobal = document.getElementById('header-global')
      const headerMain = document.getElementById('header-main')
      const headerHeight = headerGlobal.offsetHeight + headerMain.offsetHeight
      const secNav = document.getElementById('secondary-navigation')
      const secNavHeight = secNav ? secNav.offsetHeight : 0
      return headerHeight + secNavHeight
    },
    scope() {
      return {
        greetingSignInIsMounted: this.greetingSignInIsMounted,
      }
    },
    alertIsVisible() {
      return this.alert?.visible
    },
    alertIsFixed() {
      return this.alert?.isFixed
    }
  },
  created() {
    this.handleEvents()
  },
  async mounted() {
    this.mainTopSpacing()
    if (this.isSitecore) return
    await this.updateSpaceBetweenNavs()
    if (this.spaceBetweenNavs < 0) this.unsticked = true
    window.addEventListener('resize', this.updateSpaceBetweenNavs)
    window.addEventListener('scroll', () => {
      this.setupListeners()
    })
    const headerMain = document.getElementById('header-main')
    if (headerMain.classList.contains('transparent') && this.fixedHeader) {
      document.querySelector('div.header-logo').classList.add('bigger-logo')
    }
    this.$nextTick(() => {
      this.alert = this.$root.$refs.alert
      if (this.alertIsVisible && this.alertIsFixed) {
        const sideBarContainer = document.querySelector('nav.sidebar-nav-container')
        const mainSiteContainer = document.querySelector('main.main-site-container')
        document.getElementById('header').style.paddingTop = `${this.alert.$el.clientHeight}px`
        sideBarContainer?.classList?.add('alert-visible')
        mainSiteContainer?.classList?.add('alert-visible')
      }
    })
  },
  destroyed() {
    if (this.isSitecore) return
    window.removeEventListener('resize', this.updateSpaceBetweenNavs)
    window.removeEventListener('scroll', () => {
      this.setupListeners()
    })
  },
  watch: {
    spaceBetweenNavs(val) {
      const secNav = document.getElementById('secondary-navigation')
      const mastHead = document.querySelector('.masthead.component')
      if (!secNav && !mastHead) {
        this.unsticked = true
        return
      }
      if (this.isSitecore) return
      const headerMain = document.getElementById('header-main')
      const logo = document.querySelector('div.header-logo')
      if (val <= 0) {
        this.unsticked = true
        if (headerMain.classList.contains('transparent')) {
          headerMain.classList.add('force-solid')

          if (this.fixedHeader) {
            logo.classList.remove('bigger-logo')
          }
        }
      } else {
        this.unsticked = false

        headerMain.classList.remove('force-solid')

        if (headerMain.classList.contains('transparent') && this.fixedHeader) {
          logo.classList.add('bigger-logo')
        }
      }
    }
  },
  methods: {
    mainTopSpacing() {
      const main = document.querySelector('main')
      const headerMain = document.querySelector('.header-main')
      const headerIsTransparent = headerMain.classList.contains('transparent')
      if (headerIsTransparent || this.isSitecore) main.classList.add('no-top-spacing')
    },
    setupListeners() {
      this.defineScrollingDirection()
      this.updateSpaceBetweenNavs()
      this.updateVisibleBodyArea()
      this.updateHeaderPosition(this.unsticked)
      this.scrollingTimeout()
    },
    defineScrollingDirection() {
      if (this.oldScroll > window.scrollY) {
        this.isScrollingUp = true
      } else {
        this.isScrollingUp = false
      }
      this.oldScroll = window.scrollY
    },
    updateSpaceBetweenNavs() {
      const header = document.getElementById('header')
      const headerGlobal = document.getElementById('header-global')
      const headerMain = document.getElementById('header-main')
      const headerHeight = headerGlobal.offsetHeight + headerMain.offsetHeight
      const secNav = document.getElementById('secondary-navigation')
      const secNavTop = secNav ? secNav.getBoundingClientRect().top : 0
      const mastHead = document.querySelector('.masthead.component')
      const mastHeadDescription = document.querySelector('.masthead-description.container')
      const mastHeadDescriptionHeight = mastHeadDescription ? mastHeadDescription.offsetHeight : 0
      const mastHeadBottom = mastHead ? mastHead.getBoundingClientRect().bottom : 0
      const sideBarContainer = document.querySelector('nav.sidebar-nav-container')
      const mainSiteContainer = document.querySelector('main.main-site-container')
      if (this.alertIsVisible && this.alertIsFixed) {
        header.style.paddingTop = `${this.alert.$el.clientHeight}px`
        sideBarContainer?.classList?.add('alert-visible')
        mainSiteContainer?.classList?.add('alert-visible')
      } else {
        header.style.paddingTop = '0px'
        sideBarContainer?.classList?.remove('alert-visible')
        mainSiteContainer?.classList?.remove('alert-visible')
      }
      if (secNav) {
        this.spaceBetweenNavs = secNavTop - headerHeight
      } else {
        this.spaceBetweenNavs = (mastHeadBottom - mastHeadDescriptionHeight) - headerHeight
      }
    },
    updateVisibleBodyArea() {
      const footer = document.getElementById('footer')
      this.visibleBodyArea = footer.getBoundingClientRect().top - this.headerNavHeight
    },
    updateHeaderPosition(unsticked) {
      const header = document.getElementById('header')
      const headerGlobal = document.getElementById('header-global')
      const headerMain = document.getElementById('header-main')
      const alert = document.querySelector('.alert.component')
      const alertHeight = alert ? alert.offsetHeight : 0
      const headerHeight = headerGlobal.offsetHeight + headerMain.offsetHeight
      const secNav = document.getElementById('secondary-navigation')
      if (secNav) secNav.style.top = 0
      if (this.isScrollingUp && this.visibleBodyArea > 0) {
        header.style.top = 0
        header.style.transition = 'top 0.2s'
        if (secNav) secNav.style.top = `${headerHeight + alertHeight}px`
      } else if (unsticked && window.scrollY >= headerHeight && !this.fixedHeader) {
        if (secNav) {
          header.style.transition = 'none'
          header.style.top = `${secNav.getBoundingClientRect().top - headerHeight - alertHeight}px`
        } else {
          header.style.transition = 'top 0.2s'
          header.style.top = `${-(headerHeight + alertHeight)}px`
        }
      } else {
        header.style.transition = 'top 0.2s'
        header.style.top = 0
      }
    },
    scrollingTimeout() {
      if (this.isFirstLoad) {
        this.isFirstLoad = false
        return
      }
      window.clearTimeout(this.isScrolling)
      this.isScrolling = setTimeout(() => {
        this.restoreHeader()
      }, 1000)
    },
    restoreHeader() {
      const header = document.getElementById('header')
      const headerGlobal = document.getElementById('header-global')
      const headerMain = document.getElementById('header-main')
      const headerHeight = headerGlobal.offsetHeight + headerMain.offsetHeight
      const secNav = document.getElementById('secondary-navigation')
      const alert = document.querySelector('.alert.component')
      const alertHeight = alert ? alert.offsetHeight : 0
      if (this.visibleBodyArea > 0 && secNav) {
        header.style.top = 0
        secNav.style.top = `${headerHeight + alertHeight}px`
        header.style.transition = 'top 0.2s'
      } else if (this.visibleBodyArea > 0 && !secNav) {
        header.style.transition = 'top 0.2s'
        header.style.top = 0
      } else {
        header.style.transition = 'none'
        header.style.top = `${-headerHeight}px`
      }
    },
    greetingSignInMounted() {
      this.greetingSignInIsMounted = true
    },
    handleEvents() {
      this.$root.$on('greeting-sign-in-mounted', this.greetingSignInMounted)
    }
  },
  render() {
    return this.$scopedSlots.default(this.scope)
  }
}
